import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import image from '../img/social-image.png'
import './index.css'
import '../../custom-bootstrap/build/index.css'
import favicon16 from '../img/favicon-16x16.png'
import favicon32 from '../img/favicon-32x32.png'
import favicon196 from '../img/favicon-196x196.png'
import favicon from '../img/favicon.ico'

const Layout = ({ data, children, location }) => {
  const currentURL = data.site.siteMetadata.url + location
  const { title } = data.site.siteMetadata
  const description =
    'A better way to work with document templates. Create and edit documents with confidence and ease in Microsoft Word.'
  return (
    <div>
      <Helmet>
        {/* General tags */}
        <title>Document templates for Microsoft Word- {title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="templates, word templates, document automation, document templates, word, microsoft word"
        />
        <meta name="image" content={image} />
        <link rel="icon" type="image/png" href={favicon16} sizes="16x16" />
        <link rel="icon" type="image/png" href={favicon32} sizes="32x32" />
        <link rel="icon" type="image/png" href={favicon196} sizes="196x196" />
        <link href={favicon} rel="shortcut icon" />

        {/* Schema.org tags */}
        {/* <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script> */}

        <meta
          name="google-site-verification"
          content="dPbEAWLinX7N8DdXDn3YpAOkwSBTuQp1wXtgeZFm_BU"
        />
        {/* OpenGraph tags */}
        <meta property="og:url" content={currentURL} />
        {/* {isBlogPost ? <meta property="og:type" content="article" /> : null} */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        {/* <meta property="og:image" content={image} /> */}
        {/* <meta property="fb:app_id" content={config.fbAppID} /> */}

        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content={data.site.siteMetadata.twitter} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {/* <meta name="twitter:image" content={image} /> */}
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} location={location} />
      <div className="main">{children()}</div>
      <Footer siteTitle={data.site.siteMetadata.title} />
    </div>
  )
}

Layout.propTypes = {
  data: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        twitter
        url
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js